/**
 * 日期格式化
 * let time = new Date().format('yyyy-MM-dd hh:mm:ss')
 */
Date.prototype.format = function(fmt) {
  let o = {
    'M+': this.getMonth() + 1, //月份 
    'd+': this.getDate(), //日 
    'h+': this.getHours(), //小时 
    'm+': this.getMinutes(), //分 
    's+': this.getSeconds(), //秒 
    //季度 
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
const getParams = (str = window.location.href) => {
    let params = str.split('?')
    if (params.length < 2) return {}
    let param = params[1].split('&')
    let obj = {}
    for (let i = 0; i < param.length; i++) {
      let paramsA = param[i].split('=')
      let key = paramsA[0]
      let value = paramsA[1]
      obj[key] = value
    }
    return obj
  }
  /**num：要转换的数值，fixed：精确几位小数 */
const decimal = (num, fixed) => {
  let pow = Math.pow(10, fixed)
  return Math.round(num * pow) / pow
}
import Vue from 'vue'
const utils = {
  getParams,
  decimal
}
Object.keys(utils).map(key => {
  Vue.prototype[key] = utils[key]
})